import { render, staticRenderFns } from "./PostTrust.vue?vue&type=template&id=37eccdee&"
import script from "./PostTrust.vue?vue&type=script&lang=js&"
export * from "./PostTrust.vue?vue&type=script&lang=js&"
import style0 from "./PostTrust.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports